import { create } from 'zustand'

const CHIAVE_COLLASSATA = 'ringcoach-sidebar-collapsed'

interface StatoSidebar {
  /** Stato desktop: true = collassata (64px) */
  collassata: boolean
  /** Stato mobile: drawer aperto (overlay) */
  drawerAperto: boolean
  toggleCollassata: () => void
  apriDrawer: () => void
  chiudiDrawer: () => void
}

export const useSidebarStore = create<StatoSidebar>((set, get) => ({
  collassata: localStorage.getItem(CHIAVE_COLLASSATA) === '1',
  drawerAperto: false,
  toggleCollassata: () => {
    const nuovo = !get().collassata
    localStorage.setItem(CHIAVE_COLLASSATA, nuovo ? '1' : '0')
    set({ collassata: nuovo })
  },
  apriDrawer: () => set({ drawerAperto: true }),
  chiudiDrawer: () => set({ drawerAperto: false }),
}))
